import React, { useState,useEffect } from "react";
import { Space, Button, Form, DatePicker } from "antd";
import dayjs from "dayjs";
const { RangePicker } = DatePicker;

const DateRangeSelector = ({ value, onChange, onPresetChange }) => {


  const [activeButton, setActiveButton] = useState(null);

  useEffect(() => {
    if (value === null) {
      setActiveButton(null);
    }
  }, [value]);

  /* handle date button clicks */
  const handleDateShortcut = (type) => {
    setActiveButton(type);
    let startDate, endDate;

    switch (type) {
      case "today":
        startDate = dayjs().startOf("day");
        endDate = dayjs().endOf("day");
        break;
      case "week":
        startDate = dayjs().startOf("week");
        endDate = dayjs().endOf("week");
        break;
      case "month":
        startDate = dayjs().startOf("month");
        endDate = dayjs().endOf("month");
        break;
      case "year":
        startDate = dayjs().startOf("year");
        endDate = dayjs().endOf("year");
        break;
      default:
        return;
    }

    onChange?.([startDate, endDate]);
    const presetTypeMap = {
      today: "TODAY",
      week: "THIS_WEEK",
      month: "THIS_MONTH",
      year: "THIS_YEAR",
    };
    onPresetChange?.(presetTypeMap[type], [startDate, endDate]);
  };

  const handleClear = () => {
    setActiveButton(null);
    onChange?.(null);
    onPresetChange?.("ALL", null);
  };

  // Disable future dates
  const disabledDate = (current) => {
    if (!current) return false;
    return current.isAfter(dayjs(), 'day');
  };

  return (
    <Space>
      <Button
        type={activeButton === "today" ? "primary" : "default"}
        onClick={() => handleDateShortcut("today")}
      >
        Today
      </Button>
      <Button
        type={activeButton === "week" ? "primary" : "default"}
        onClick={() => handleDateShortcut("week")}
      >
        This week
      </Button>
      <Button
        type={activeButton === "month" ? "primary" : "default"}
        onClick={() => handleDateShortcut("month")}
      >
        This month
      </Button>
      <Button
        type={activeButton === "year" ? "primary" : "default"}
        onClick={() => handleDateShortcut("year")}
      >
        This year
      </Button>

      <Form.Item style={{ marginBottom: 0 }}>
        <RangePicker
          value={value}
          /* when dates is changed, update parent state using function passed from parent */
          onChange={(dates) => {
            onChange?.(dates);
            setActiveButton(null);
            if (dates && dates[0] && dates[1]) {
              onPresetChange?.("CUSTOM", dates);
            } else {
              // When dates is null or empty, it means cleared
              onPresetChange?.("ALL", null);
            }
          }}
          onClear={() => {
            setActiveButton(null);
            onPresetChange?.("ALL", null);
          }}
          disabledDate={disabledDate}
          style={{ width: 280 }}
          placeholder={["Start date", "End date"]}
          allowClear
        />
      </Form.Item>

    </Space>
  );
};

export default DateRangeSelector;


